/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { XenialCatalogResponse } from '../../models/xenial-catalog-response';

export interface XenialCatalogsCatalogEntryIdGet$Params {
  'Active-Tenant-Identifier': string;
  catalogEntryId: string;
}

export function xenialCatalogsCatalogEntryIdGet(http: HttpClient, rootUrl: string, params: XenialCatalogsCatalogEntryIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<XenialCatalogResponse>> {
  const rb = new RequestBuilder(rootUrl, xenialCatalogsCatalogEntryIdGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('catalogEntryId', params.catalogEntryId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<XenialCatalogResponse>;
    })
  );
}

xenialCatalogsCatalogEntryIdGet.PATH = '/xenial/catalogs/{catalogEntryId}';
